export default class DirectClientMessageBus {
    constructor() {
        this.listeners = [];
        this.peers = [];
    }
    addPeer(peer) {
        this.peers.push(peer);
    }
    send(data) {
        this.peers.forEach((peer) => {
            peer.listeners.forEach((listener) => {
                listener(data);
            });
        });
    }
    onReceive(callback) {
        this.listeners.push(callback);
    }
    cleanup() {
        this.listeners = [];
        this.peers = [];
    }
}
//# sourceMappingURL=direct-client.js.map